import {TypePeriodeFacturationEnum} from "../../../../enums/facturation/client/type-periode-facturation-enum";
import {TypeFactureClientEnum} from "../../../../enums/facturation/client/type-facture-client-enum";

export default class LigneParametrageFactureClientFilterDto {
  typePeriode: TypePeriodeFacturationEnum[] = [];
  typeFactureClient: TypeFactureClientEnum;

  constructor(typePeriode: TypePeriodeFacturationEnum[], typeFactureClient: TypeFactureClientEnum) {
    this.typePeriode = typePeriode;
    this.typeFactureClient = typeFactureClient;
  }
}
